/**
 * Adapptio Shared library.
 *
 * @package lib-shared
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const capitalizeFirstLetter = (string: string) => {
	if (string?.length) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	return "";
};
